import { render, staticRenderFns } from "./Bankkbank.vue?vue&type=template&id=2ba7de28"
import script from "./Bankkbank.vue?vue&type=script&lang=js"
export * from "./Bankkbank.vue?vue&type=script&lang=js"
import style0 from "./Bankkbank.vue?vue&type=style&index=0&id=2ba7de28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports